define(["exports", "./xref-db", "./utils", "./pubsubhub"], function (_exports, _xrefDb, _utils, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.API_URL = void 0;

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const profiles = {
    "web-platform": ["HTML", "INFRA", "URL", "WEBIDL", "DOM", "FETCH"]
  };
  const API_URL = "https://respec.org/xref/";
  _exports.API_URL = API_URL;

  if (!document.querySelector("link[rel='preconnect'][href='https://respec.org']")) {
    const link = (0, _utils.createResourceHint)({
      hint: "preconnect",
      href: "https://respec.org"
    });
    document.head.appendChild(link);
  }
  /**
   * main external reference driver
   * @param {Object} conf respecConfig
   * @param {HTMLElement[]} elems possibleExternalLinks
   */


  async function run(conf, elems) {
    const xref = normalizeConfig(conf.xref);

    if (xref.specs) {
      const bodyCite = document.body.dataset.cite ? document.body.dataset.cite.split(/\s+/) : [];
      document.body.dataset.cite = bodyCite.concat(xref.specs).join(" ");
    }

    if (!elems.length) return;
    /** @type {RequestEntry[]} */

    const queryKeys = [];

    for (const elem of elems) {
      const entry = getRequestEntry(elem);
      const id = await objectHash(entry);
      queryKeys.push(_objectSpread({}, entry, {
        id
      }));
    }

    const data = await getData(queryKeys, xref.url);
    addDataCiteToTerms(elems, queryKeys, data, conf);
  }
  /**
   * converts conf.xref to object with url and spec properties
   */


  function normalizeConfig(xref) {
    const defaults = {
      url: API_URL,
      specs: null
    };
    const config = Object.assign({}, defaults);
    const type = Array.isArray(xref) ? "array" : typeof xref;

    switch (type) {
      case "boolean":
        // using defaults already, as above
        break;

      case "string":
        if (xref.toLowerCase() in profiles) {
          Object.assign(config, {
            specs: profiles[xref.toLowerCase()]
          });
        } else {
          invalidProfileError(xref);
        }

        break;

      case "array":
        Object.assign(config, {
          specs: xref
        });
        break;

      case "object":
        Object.assign(config, xref);

        if (xref.profile) {
          const profile = xref.profile.toLowerCase();

          if (profile in profiles) {
            const specs = (xref.specs || []).concat(profiles[profile]);
            Object.assign(config, {
              specs
            });
          } else {
            invalidProfileError(xref.profile);
          }
        }

        break;

      default:
        (0, _pubsubhub.pub)("error", "Invalid value for `xref` configuration option. Received: \"".concat(xref, "\"."));
    }

    return config;

    function invalidProfileError(profile) {
      const supportedProfiles = Object.keys(profiles).map(p => "\"".concat(p, "\"")).join(", ");
      const msg = "Invalid profile \"".concat(profile, "\" in `respecConfig.xref`. ") + "Please use one of the supported profiles: ".concat(supportedProfiles, ".");
      (0, _pubsubhub.pub)("error", msg);
    }
  }
  /**
   * get xref API request entry (term and context) for given xref element
   * @param {HTMLElement} elem
   */


  function getRequestEntry(elem) {
    const isIDL = "xrefType" in elem.dataset;
    let term = getTermFromElement(elem);
    if (!isIDL) term = term.toLowerCase();
    /** @type {string[][]} */

    const specs = [];
    /** @type {HTMLElement} */

    let dataciteElem = elem.closest("[data-cite]");

    while (dataciteElem) {
      const cite = dataciteElem.dataset.cite.toLowerCase().replace(/[!?]/g, "");
      const cites = cite.split(/\s+/).filter(s => s);

      if (cites.length) {
        specs.push(cites.sort());
      }

      if (dataciteElem === elem) break;
      dataciteElem = dataciteElem.parentElement.closest("[data-cite]");
    } // if element itself contains data-cite, we don't take inline context into account


    if (elem.closest("[data-cite]") !== elem) {
      const closestSection = elem.closest("section");
      /** @type {Iterable<HTMLElement>} */

      const bibrefs = closestSection ? closestSection.querySelectorAll("a.bibref") : [];
      const inlineRefs = [...bibrefs].map(el => el.textContent.toLowerCase());
      const uniqueInlineRefs = [...new Set(inlineRefs)].sort();

      if (uniqueInlineRefs.length) {
        specs.unshift(uniqueInlineRefs);
      }
    }

    const types = [];

    if (isIDL) {
      if (elem.dataset.xrefType) {
        types.push(...elem.dataset.xrefType.split("|"));
      } else {
        types.push("_IDL_");
      }
    } else {
      types.push("_CONCEPT_");
    }

    let {
      xrefFor: forContext
    } = elem.dataset;

    if (!forContext && isIDL) {
      /** @type {HTMLElement} */
      const dataXrefForElem = elem.closest("[data-xref-for]");

      if (dataXrefForElem) {
        forContext = (0, _utils.norm)(dataXrefForElem.dataset.xrefFor);
      }
    } else if (forContext && typeof forContext === "string") {
      forContext = (0, _utils.norm)(forContext);
    }

    return _objectSpread({
      term,
      types
    }, specs.length && {
      specs
    }, {}, typeof forContext === "string" && {
      for: forContext
    });
  }
  /** @param {HTMLElement} elem */


  function getTermFromElement(elem) {
    const {
      lt: linkingText
    } = elem.dataset;
    let term = linkingText ? linkingText.split("|", 1)[0] : elem.textContent;
    term = (0, _utils.norm)(term);
    return term === "the-empty-string" ? "" : term;
  }
  /**
   * @param {RequestEntry[]} queryKeys
   * @param {string} apiUrl
   * @returns {Promise<Map<string, SearchResultEntry[]>>}
   */


  async function getData(queryKeys, apiUrl) {
    const uniqueIds = new Set();
    const uniqueQueryKeys = queryKeys.filter(key => {
      return uniqueIds.has(key.id) ? false : uniqueIds.add(key.id) && true;
    });
    const resultsFromCache = await (0, _xrefDb.resolveXrefCache)(uniqueQueryKeys);
    const termsToLook = uniqueQueryKeys.filter(key => !resultsFromCache.get(key.id));
    const fetchedResults = await fetchFromNetwork(termsToLook, apiUrl);

    if (fetchedResults.size) {
      // add data to cache
      await (0, _xrefDb.cacheXrefData)(fetchedResults);
    }

    return new Map([...resultsFromCache, ...fetchedResults]);
  }
  /**
   * @param {RequestEntry[]} keys
   * @param {string} url
   * @returns {Promise<Map<string, SearchResultEntry[]>>}
   */


  async function fetchFromNetwork(keys, url) {
    if (!keys.length) return new Map();
    const query = {
      keys
    };
    const options = {
      method: "POST",
      body: JSON.stringify(query),
      headers: {
        "Content-Type": "application/json"
      }
    };
    const response = await fetch(url, options);
    const json = await response.json();
    return new Map(json.result);
  }
  /**
   * Figures out from the tree structure if the reference is
   * normative (true) or informative (false).
   * @param {HTMLElement} elem
   */


  function isNormative(elem) {
    const closestNormative = elem.closest(".normative");
    const closestInform = elem.closest(_utils.nonNormativeSelector);

    if (!closestInform || elem === closestNormative) {
      return true;
    }

    return closestNormative && closestInform && closestInform.contains(closestNormative);
  }
  /**
   * adds data-cite attributes to elems for each term for which results are found.
   * adds citations to references section.
   * collects and shows linking errors if any.
   * @param {HTMLElement[]} elems
   * @param {RequestEntry[]} queryKeys
   * @param {Map<string, SearchResultEntry[]>} data
   * @param {any} conf
   */


  function addDataCiteToTerms(elems, queryKeys, data, conf) {
    /** @type {Errors} */
    const errors = {
      ambiguous: new Map(),
      notFound: new Map()
    };

    for (let i = 0, l = elems.length; i < l; i++) {
      if (elems[i].closest("[data-no-xref]")) continue;
      const elem = elems[i];
      const query = queryKeys[i];
      const {
        id
      } = query;
      const results = data.get(id);

      if (results.length === 1) {
        addDataCite(elem, query, results[0], conf);
      } else {
        const collector = errors[results.length === 0 ? "notFound" : "ambiguous"];

        if (!collector.has(id)) {
          collector.set(id, {
            elems: [],
            results,
            query
          });
        }

        collector.get(id).elems.push(elem);
      }
    }

    showErrors(errors);
  }
  /**
   * @param {HTMLElement} elem
   * @param {RequestEntry} query
   * @param {SearchResultEntry} result
   * @param {any} conf
   */


  function addDataCite(elem, query, result, conf) {
    const {
      term
    } = query;
    const {
      uri,
      shortname: cite,
      normative,
      type
    } = result;
    const path = uri.includes("/") ? uri.split("/", 1)[1] : uri;
    const [citePath, citeFrag] = path.split("#");
    const dataset = {
      cite,
      citePath,
      citeFrag,
      type
    };
    Object.assign(elem.dataset, dataset); // update indirect links (data-lt, data-plurals)

    /** @type {NodeListOf<HTMLElement>} */

    const indirectLinks = document.querySelectorAll("[data-dfn-type=\"xref\"][data-xref=\"".concat(term.toLowerCase(), "\"]"));
    indirectLinks.forEach(el => {
      el.removeAttribute("data-xref");
      Object.assign(el.dataset, dataset);
    });
    addToReferences(elem, cite, normative, term, conf);
  }
  /**
   * add specs for citation (references section)
   * @param {HTMLElement} elem
   * @param {string} cite
   * @param {boolean} normative
   * @param {string} term
   * @param {any} conf
   */


  function addToReferences(elem, cite, normative, term, conf) {
    const isNormRef = isNormative(elem);

    if (!isNormRef) {
      // Only add it if not already normative...
      if (!conf.normativeReferences.has(cite)) {
        conf.informativeReferences.add(cite);
      }

      return;
    }

    if (normative) {
      // If it was originally informative, we move the existing
      // key to be normative.
      const existingKey = conf.informativeReferences.has(cite) ? conf.informativeReferences.getCanonicalKey(cite) : cite;
      conf.normativeReferences.add(existingKey);
      conf.informativeReferences.delete(existingKey);
      return;
    }

    const msg = "Adding an informative reference to \"".concat(term, "\" from \"").concat(cite, "\" ") + "in a normative section";
    const title = "Error: Informative reference in normative section";
    (0, _utils.showInlineWarning)(elem, msg, title);
  }
  /** @param {Errors} errors */


  function showErrors({
    ambiguous,
    notFound
  }) {
    const getPrefilledFormURL = (term, query, specs = []) => {
      const url = new URL(API_URL);
      url.searchParams.set("term", term);
      if (query.for) url.searchParams.set("for", query.for);
      url.searchParams.set("types", query.types.join(","));
      if (specs.length) url.searchParams.set("cite", specs.join(","));
      return url;
    };

    for (const {
      query,
      elems
    } of notFound.values()) {
      const specs = [...new Set((0, _utils.flatten)([], query.specs))].sort();
      const originalTerm = getTermFromElement(elems[0]);
      const formUrl = getPrefilledFormURL(originalTerm, query, specs);
      const specsString = specs.map(spec => "`".concat(spec, "`")).join(", ");
      const msg = "Couldn't match \"**".concat(originalTerm, "**\" to anything in the document or in any other document cited in this specification: ").concat(specsString, ". ") + "See [how to cite to resolve the error](".concat(formUrl, ")");
      (0, _utils.showInlineError)(elems, msg, "Error: No matching dfn found.");
    }

    for (const {
      query,
      elems,
      results
    } of ambiguous.values()) {
      const specs = [...new Set(results.map(entry => entry.shortname))].sort();
      const specsString = specs.map(s => "**".concat(s, "**")).join(", ");
      const originalTerm = getTermFromElement(elems[0]);
      const formUrl = getPrefilledFormURL(originalTerm, query, specs);
      const msg = "The term \"**".concat(originalTerm, "**\" is defined in ").concat(specsString, " in multiple ways, so it's ambiguous. ") + "See [how to cite to resolve the error](".concat(formUrl, ")");
      (0, _utils.showInlineError)(elems, msg, "Error: Linking an ambiguous dfn.");
    }
  }

  function objectHash(obj) {
    const str = JSON.stringify(obj, Object.keys(obj).sort());
    const buffer = new TextEncoder().encode(str);
    return crypto.subtle.digest("SHA-1", buffer).then(bufferToHexString);
  }
  /** @param {ArrayBuffer} buffer */


  function bufferToHexString(buffer) {
    const byteArray = new Uint8Array(buffer);
    return [...byteArray].map(v => v.toString(16).padStart(2, "0")).join("");
  }
});
//# sourceMappingURL=xref.js.map